<template>
    <div class="WarnTips">
            <app-header @on-click="goBack" class="head"/>
        <div class="warn-tips">
            <div class="warn-tips-icon">
                <van-icon name="warning" />
            </div>
            <div class="warn-tips-content">
                {{ $t('registerlogin.device_tips') }}
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "WarnTips",
    props: {
        tips: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            
        }
    },
    methods: {
        goBack() {
            this.$emit('cancel');
        },
    }
}
</script>

<style lang="less" scoped>
    .WarnTips {
        position: absolute;
        left: 0;
        top: 0;
        background-color: #fff;
        height: 100vh;
        width: 100vw;
        z-index: 9999;
        .warn-tips {
            padding: 0 12px;
            margin: 100px auto 0;
            text-align: center;
            font-size: 13px;
            .warn-tips-icon {
                color: #f5a623;
                font-size: 40px;
                margin-right: 2px;
                text-align: center;
                margin-bottom: 10px;
            }
        }
    }
</style>